import Vue from 'vue'
import moment from 'moment'

Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('summarize', function (value, limit) {
	if (!value) return ''

	value = value.toString()
	if (value.length >= limit) {
		value = `${value.substring(0, limit - 3)}...`
	}

	return value
})

Vue.filter('dateFormatter', function (date, format) {
	return moment(date).format(format)
})

Vue.filter('isPostDate', function (date) {
	return moment() > moment(date)
})

Vue.filter('time', function (time, format) {
	return moment(time, format).format('LT')
})

Vue.filter('null', function (value) {
	if (!value) return '-'

	return value
})

Vue.filter('stripHtmlTag', function (str) {
	if ((str === null) || (str === '')) return ''
	str = str.toString()
	return str.replace(/<[^>]+>/g, '')
})

export default Vue
